import { FC } from 'react';
import { Redirect } from 'react-router-dom';

import { useDependencies } from '@servicetitan/react-ioc';

import { useSearchParams } from '../../common/hooks/use-search-params';
import { AppSettingsStore } from '../../common/stores/app-settings.store';

export const JobPickerPage: FC = () => {
    const [appSettingsStore] = useDependencies<[AppSettingsStore]>(AppSettingsStore);
    const searchParams = useSearchParams();

    const jobIdParam = searchParams.get('job_id') ?? '';
    const jobId = +jobIdParam;

    const fromCordovaParam = searchParams.get('fromCordova');
    appSettingsStore.setOpenedFromCordova(!!fromCordovaParam);

    if (!Number.isNaN(jobId)) {
        return <Redirect to={`/${jobId}/topic-picker`} />;
    }

    return null;
};
